import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const useSqueuesStore = defineStore('squeues', {
  state: () => ({
    squeues: [],
    fetchInitiated: false,
  }),

  getters: {
    enabled({ squeues }) {
      return squeues.filter(squeue => squeue.enabled)
    },

    enabledAsObject({ squeues }) {
      return squeues.filter(squeue => squeue.enabled).reduce((obj, squeue) => {
        obj[squeue.title] = squeue.id
        return obj
      }, {})
    },

    forId: ({ squeues }) => (id) => {
      return squeues.find(squeue => squeue.id === id)
    },
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/squeues')
        .then(response => {
          this.squeues = response.data.squeues
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },
  },
})
